import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  const handleReservation = () => {
    const element = document.querySelector('#reservation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLineContact = () => {
    window.open('https://line.me/R/ti/p/@luciall', '_blank');
  };

  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fe8e83020867fd6e675cff77ac9f58d4.jpg"
          alt="LUCIALL サロン内観"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <p className="text-gold text-sm md:text-base font-medium mb-4 tracking-widest">
          五位堂駅徒歩2分
        </p>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-4 leading-tight tracking-wide">
          結果にこだわる<br className="md:hidden" />プライベートエステ
        </h1>
        <p className="text-white text-base md:text-lg lg:text-xl mb-8 md:mb-12 leading-relaxed font-light max-w-2xl mx-auto">
          最新マシン×熟練ハンドで、理想の美ボディ＆素肌へ<br />
          痩身・美肌・頭皮ケアまで、"今の自分を変えたい"大人女性のためのトータルケアサロン
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 px-4">
          <button
            onClick={handleReservation}
            className="w-full sm:w-auto bg-gold text-white px-8 py-4 rounded-full text-base md:text-lg font-semibold hover:bg-gold/90 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            今すぐ予約する
          </button>
          <button
            onClick={handleLineContact}
            className="w-full sm:w-auto bg-white text-gold border-2 border-white px-8 py-4 rounded-full text-base md:text-lg font-semibold hover:bg-gold hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            LINEで相談する
          </button>
        </div>

        {/* Scroll Hint */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-gold text-3xl"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
